/*
 * groupPeople Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import {
    GROUP_CREATE_SUCCEEDED,
    GROUP_UPDATE_SUCCEEDED,
    GROUP_DELETE_SUCCEEDED
} from '../groups/constants';
import { PERSON_DELETE_SUCCEEDED } from '../people/constants';
import { RESET_STATE } from '../auth/constants';
import { ADDED_GROUPS_TO_PERSON } from './constants';

const initialState = [];

export default function(state = initialState, action) {
    switch (action.type) {
        case ADDED_GROUPS_TO_PERSON: {
            const { personId, groupIds = [] } = action.payload;
            const groupPeople = groupIds.map(groupId => ({
                personId,
                groupId
            }));
            return state
                .filter(value => value.personId !== Number(personId))
                .concat(groupPeople);
        }
        // Legacy beyond this point
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'response.groupPeople', []);
        case GROUP_CREATE_SUCCEEDED: {
            const groupPeople = get(action, 'response.people', []);
            return state.concat(groupPeople);
        }
        // case PERSON_CREATE_SUCCEEDED: {
        //   const groupPeople = get(action, 'response.groups', []);
        //   return state.concat(groupPeople);
        // }
        case GROUP_UPDATE_SUCCEEDED: {
            const groupPeople = get(action, 'response.people', []);
            return state
                .filter(value => value.groupId !== Number(action.id))
                .concat(groupPeople);
        }
        // case PERSON_UPDATE_SUCCEEDED: {
        //   const groupPeople = get(action, 'response.groups', []);
        //   return state
        //     .filter(value => value.personId !== Number(action.id))
        //     .concat(groupPeople);
        // }
        case GROUP_DELETE_SUCCEEDED: {
            return state.filter(value => value.groupId !== Number(action.id));
        }
        case PERSON_DELETE_SUCCEEDED: {
            return state.filter(value => value.personId !== Number(action.id));
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
